import React, { useEffect } from 'react';
import { Container } from 'reactstrap';
import { Routes, Route } from 'react-router';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';
import AppContainer from 'AppContainer';
import { ProtectedRoute } from 'components/ProtectedRoute';
import ForgotePassword from 'pages/ForgotePassword';
import Login from 'pages/Login';
import UserDesh from 'pages/UserDesh';
import AllPartners from 'pages/Partners/PartnersList';
import Customers from 'pages/Customers';
import ContactUs from 'pages/ContactUs';
import Feedback from "pages/Feedback's";
import { CustomersProvider } from 'pages/Customers/context';
import { BookingsProvider } from 'pages/Bookings/context';
import CustomerDetail from './pages/Customers/components/CustomerDetail';
import BookingsDetail from './pages/Bookings/components/BookingDetail';
import { UsersDetailProvider } from 'pages/Customers/components/CustomerDetail/userContextDetail';
import PartnerDetails from 'pages/Partners/PartnerDetails';
import BookingList from 'pages/Bookings/components/List';
import { BookingsDetailProvider } from 'pages/Bookings/components/BookingDetail/bookingContextDetail';
import { DashboardProvider } from 'pages/UserDesh/context';
import { PartnersContextProvider } from 'pages/Partners/PartnersList/context';
import Partners from 'pages/Partners';
import CustomerLayout from 'CustomerLayout';
import { PartnerDetailsProvider } from 'pages/Partners/PartnerDetails/partnerDetailsContext';
import { PartnereDetailsProvier } from 'hooks/useBooking';
import { Bookings } from 'pages/Bookings';
import {
  requestFirebaseNotificationPermission,
  onFirebaseMessageListener,
} from './firebaseNotification';

const App = () => {
  useEffect(() => {
    requestFirebaseNotificationPermission();
    onFirebaseMessageListener().then((payload: any) => {
      alert(
        `Notification: ${payload.notification.title} - ${payload.notification.body}`,
      );
    });
  }, []);

  return (
    <Container fluid>
      <React.Suspense fallback="">
        <Routes>
          {/* <Route path='/' element={<Home />} /> */}
          <Route index path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotePassword />} />
          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <AppContainer />
              </ProtectedRoute>
            }
          >
            <Route
              index
              path="dashboard"
              element={
                <DashboardProvider>
                  <BookingsProvider>
                    <UserDesh />
                  </BookingsProvider>
                </DashboardProvider>
              }
            />

            {/* //nested outlet */}

            <Route
              path="/app/customers"
              element={
                <CustomersProvider>
                  <CustomerLayout />
                </CustomersProvider>
              }
            >
              <Route index element={<Customers />} />
              <Route
                path=":customerId/details"
                element={
                  <UsersDetailProvider>
                    <CustomerDetail />
                    {/* </PartnersContextProvider> */}
                  </UsersDetailProvider>
                }
              />
            </Route>

            <Route path="partners" element={<Partners />}>
              <Route
                index
                element={
                  <PartnersContextProvider>
                    <AllPartners />
                  </PartnersContextProvider>
                }
              />
              <Route
                path=":partnerId/details"
                element={
                  <PartnerDetailsProvider>
                    <PartnereDetailsProvier>
                      <PartnerDetails />
                    </PartnereDetailsProvier>
                  </PartnerDetailsProvider>
                }
              />
            </Route>

            <Route path="bookings" element={<Bookings />}>
              <Route
                index
                element={
                  <BookingsProvider>
                    <BookingList />
                  </BookingsProvider>
                }
              />
              <Route
                path=":bookingId/details"
                element={
                  <BookingsDetailProvider>
                    <PartnersContextProvider>
                      <UsersDetailProvider>
                        <BookingsDetail />
                      </UsersDetailProvider>
                    </PartnersContextProvider>
                  </BookingsDetailProvider>
                }
              />
            </Route>

            <Route path="reviews" element={<Feedback />} />
            <Route path="leads" element={<ContactUs />} />
            {/* <Route path='partner-dashboard' element={<PartnerDesh />} /> */}
          </Route>
        </Routes>
      </React.Suspense>

      {/* <ToastContainer /> */}
    </Container>
  );
};

export default App;
